import { ApolloError } from '@apollo/client';

import { utils as commonUtils } from '@finley-technologies/common';

// Constants
const DEFAULT_ERROR_MESSAGE =
  'An unexpected error occurred. Please contact Finley for support.';

// Exports
/**
 * Manages error message that we want to display for ApolloError.
 * At the moment, defaulting to initial error instance (same as usual behavior).
 * From there, prioritize based on availability:
 * - "externalMessage" from our errors
 * - "message" if not in prod since this internal attribute may contain sensitive info
 * - Otherwise use provided default message or our base one
 */
export const getErrorMessageFromApolloError = (params: {
  error: any;
  defaultMessage?: string;
}): string => {
  const { error, defaultMessage } = params;

  if (!(error instanceof ApolloError)) {
    return defaultMessage ?? DEFAULT_ERROR_MESSAGE;
  }

  const targetGqlError = error.graphQLErrors[0];

  const adjustedDefaultMessage = !commonUtils.EnvUtils.isCustomerFacing()
    ? targetGqlError?.extensions?.exception?.message ?? defaultMessage
    : defaultMessage;

  return (
    targetGqlError?.extensions?.exception?.externalMessage ??
    adjustedDefaultMessage ??
    DEFAULT_ERROR_MESSAGE
  );
};
